/**
 * Styled components for PanelChatHeader
 */

import styled from 'styled-components';


/**
 * Wrapper for the chat panel header
 * Replaces: chat-panel-header d-flex flex-row align-items-center justify-content-between
 * Positioned to sit next to the close icon using negative top margin
 */
export const PanelChatHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.color.chatPanel};
  
  /* From chat-panel.scss */
  line-height: 1;
  margin: -38px 0 10px 30px; /* Negative top margin positions next to close icon */
  flex-shrink: 0;
  position: relative;
  z-index: 1; /* Ensure it sits above the Header component */
  
  h4 {
    margin-bottom: 0;
    margin-top: 0;
    font-size: ${({ theme }) => theme.font.size.large} !important;
    font-weight: ${({ theme }) => theme.font.weight.regular} !important;
    line-height: 1 !important;
  }
`;

/**
 * Branding text wrapper - uses small font size
 */
export const HeaderBrandingWrapper = styled.div`
  font-size: ${({ theme }) => theme.font.size.small};
`;
